/* ============================================================
   Lead Form 2.0 — modal behavior
   - open/close (button click, scrim click, ESC)
   - body scroll lock
   - on open: sync quantity + price from live PDP fields
   - drag-and-drop file upload (max 5 files, 50MB total)
   - client-side validation
   - AJAX POST to /contact (Shopify contact form)
   - reliable success "Thank you" state after submit
   ============================================================ */
(function(){
  'use strict';
  var modal = document.getElementById('lfm-modal-root');
  if (!modal) return;

  var form = modal.querySelector('.lfm-form');
  var uploaderySlot = modal.querySelector('#lfm-uploadery-slot');
  var cta = modal.querySelector('.lfm-cta');
  var ctaLabel = modal.querySelector('.lfm-cta-label');
  var bannerEl = modal.querySelector('.lfm-form-banner');
  var lastFocusedTrigger = null;

  // ─── Uploadery integration ───────────────────────────────
  // Matches the legacy product_contact_form.liquid pattern: the Uploadery app
  // injects #uploadery-container somewhere on the PDP at page load. We move
  // it into our slot when the modal opens, and rename the hidden URL input
  // it creates (#design_uploads) so the S3 URL submits as contact[file_url].
  function syncUploaderyIntoModal(){
    if (!uploaderySlot) return;
    var uploadery = document.getElementById('uploadery-container');
    if (uploadery && uploadery.parentElement !== uploaderySlot){
      uploaderySlot.appendChild(uploadery);
    }
    var urlInput = document.getElementById('design_uploads');
    if (urlInput){
      if (urlInput.getAttribute('name') !== 'contact[file_url]'){
        urlInput.setAttribute('name', 'contact[file_url]');
      }
      // Uploadery wraps its controls in a nested <form data-uploadery>. Without
      // this attribute the input is associated with that inner form and gets
      // dropped from our outer form's submission — so contact[file_url] never
      // makes it to Shopify and File Url is missing from the inquiry email.
      if (urlInput.getAttribute('form') !== 'lfm-form'){
        urlInput.setAttribute('form', 'lfm-form');
      }
    }
  }

  // ─── Uploadery attached-state UI ─────────────────────────
  // Reflect Uploadery's upload status in our drop zone by toggling .has-file
  // on #lfm-uploadery-slot. The default prompt swaps to a green check + the
  // filename + a Remove link. We poll because Uploadery sets the input value
  // via JS, which doesn't fire a native 'change' event.
  function updateUploaderyAttachedState(){
    if (!uploaderySlot) return;
    var urlInput = document.getElementById('design_uploads');
    var val = urlInput && urlInput.value ? String(urlInput.value).trim() : '';
    var hasFile = /^https?:\/\//i.test(val);
    uploaderySlot.classList.toggle('has-file', hasFile);
    if (hasFile){
      var nameEl = uploaderySlot.querySelector('[data-lfm-attached-name]');
      if (nameEl){
        var fname = val;
        try {
          var path = val.split('?')[0];
          var seg = decodeURIComponent(path.split('/').pop() || '');
          // Uploadery prefixes uploaded files with a hex hash like
          // "6ed90038-Academy-Service-Group-Logo.jpeg" — strip the prefix.
          fname = seg.replace(/^[a-f0-9]{6,}-/i, '') || seg;
        } catch(_){}
        nameEl.textContent = fname;
      }
    }
  }
  var uploaderyPollTimer = null;
  function startUploaderyPolling(){
    stopUploaderyPolling();
    updateUploaderyAttachedState();
    uploaderyPollTimer = setInterval(updateUploaderyAttachedState, 400);
  }
  function stopUploaderyPolling(){
    if (uploaderyPollTimer){ clearInterval(uploaderyPollTimer); uploaderyPollTimer = null; }
  }
  // Wire the Remove link once. Clicking it clears Uploadery's hidden URL
  // input so the form submits without a file_url; user can then attach
  // a different file. Also clicks Uploadery's own thumbnail-remove control
  // if it rendered one, so its internal state stays consistent.
  (function wireUploaderyRemove(){
    if (!uploaderySlot) return;
    var removeBtn = uploaderySlot.querySelector('[data-lfm-attached-remove]');
    if (!removeBtn) return;
    removeBtn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var urlInput = document.getElementById('design_uploads');
      if (urlInput) urlInput.value = '';
      try {
        var uploadery = document.getElementById('uploadery-container');
        if (uploadery){
          var btn = uploadery.querySelector('.design-thumbnail-removelink, .design-thumbnail-removeicon, .remove-file, [data-remove]');
          if (btn && btn.click) btn.click();
        }
      } catch(_){}
      updateUploaderyAttachedState();
    });
  })();

  // ─── PDP data readers ────────────────────────────────────
  // These selectors target the chocomize.com PDP. If the markup changes,
  // update here. Multiple fallbacks for resilience.
  function readPdpQuantity(){
    var sel = [
      'input[name="quantity"].js-counter-quantity',
      'input.js-counter-quantity',
      'input[name="quantity"]',
      'input[name="qty"]',
      '[data-quantity-input]'
    ];
    for (var i = 0; i < sel.length; i++){
      var el = document.querySelector(sel[i]);
      if (el && el.value){
        var n = parseInt(String(el.value).replace(/[^\d]/g,''), 10);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return null;
  }
  function readPdpTotalPrice(){
    var sel = [
      '#total-price',
      '.total-price',
      '[data-total-price]',
      '.custom_price_container .price',
      '.custom_price_container'
    ];
    for (var i = 0; i < sel.length; i++){
      var el = document.querySelector(sel[i]);
      if (!el) continue;
      var text = el.textContent || '';
      // Strip any "$X[.YY] [...] setup fee" segments before scanning so the
      // regex below can't grab the setup-fee amount when the product subtotal
      // hasn't finished computing yet. Without this we'd return the setup fee
      // (e.g. $49.00) and downstream code would divide by qty → bogus unit
      // price like $0.49/unit on a 100-unit Tin order.
      var cleaned = text.replace(/\+?\s*\$[\d,]+(?:\.\d+)?\s*[^$]{0,40}setup\s*fee/ig, ' ')
                        .replace(/setup\s*fee[^$]{0,40}\$[\d,]+(?:\.\d+)?/ig, ' ');
      var m = cleaned.match(/\$[\d,]+(?:\.\d+)?/);
      if (m) return m[0];
    }
    return null;
  }
  // The PDP shows the per-product setup fee next to the total price, e.g.
  // "+ $49.00 Setup Fee". We look for a dedicated element first, then fall
  // back to scanning likely containers for the "$X Setup Fee" pattern.
  function readPdpSetupFee(){
    var direct = [
      '[data-setup-fee]',
      '.setup-fee',
      '.setup-fee-amount',
      '.product-setup-fee'
    ];
    for (var i = 0; i < direct.length; i++){
      var el = document.querySelector(direct[i]);
      if (el){
        var m = (el.textContent || '').match(/\$[\d,]+(?:\.\d+)?/);
        if (m) return m[0];
      }
    }
    var containers = document.querySelectorAll('.custom_price_container, .product-info, .product-form, .wt-product, [class*="product__form"], [class*="product-form"]');
    for (var ci = 0; ci < containers.length; ci++){
      var t = containers[ci].textContent || '';
      var match = t.match(/\$([\d,]+(?:\.\d+)?)\s*setup\s*fee/i)
              || t.match(/setup\s*fee[^\d$]*\$([\d,]+(?:\.\d+)?)/i);
      if (match) return '$' + match[1];
    }
    return null;
  }
  function parseMoneyToNumber(str){
    if (!str) return null;
    var n = parseFloat(String(str).replace(/[^\d.]/g, ''));
    return isNaN(n) ? null : n;
  }
  function fmtMoney(n){
    if (n == null || isNaN(n)) return '';
    if (n < 1) return '$' + n.toFixed(2);
    if (n < 10) return '$' + n.toFixed(2);
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ─── Submit snapshot (survives the page navigation) ─────────────────────
  // Shopify's /contact submit triggers a full page reload back to the PDP
  // with ?contact_posted=true, which resets the PDP to its default variant.
  // Without snapshotting, the success-state rail would show whatever the
  // PDP defaults to, not what the customer actually picked. We stash the
  // selection in sessionStorage right before submit and read from it when
  // the success state opens.
  function saveSubmitSnapshot(){
    try {
      var vEl = document.querySelector('form.wt-product__add-to-cart_form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      var totalStr = readPdpTotalPrice();
      var setupStr = readPdpSetupFee();
      // Sanity check: if the "total" we read is <= setup fee + 1¢, the PDP's
      // price calculator probably hasn't computed the product subtotal yet
      // (we caught only the setup-fee value). Don't snapshot a price that
      // would yield a misleading $X/unit downstream.
      var totalNum = parseMoneyToNumber(totalStr);
      var setupNum = parseMoneyToNumber(setupStr);
      if (totalNum != null && setupNum != null && totalNum <= setupNum + 0.01){
        totalStr = null;
      }
      var snap = {
        variant_id:  vEl && vEl.value ? String(vEl.value).trim() : '',
        quantity:    readPdpQuantity(),
        total_price: totalStr,
        setup_fee:   setupStr,
        t:           Date.now()
      };
      sessionStorage.setItem('lfm_submit_snapshot', JSON.stringify(snap));
    } catch(_){ /* sessionStorage can throw in private mode */ }
  }
  function readSubmitSnapshot(){
    try {
      var raw = sessionStorage.getItem('lfm_submit_snapshot');
      if (!raw) return null;
      var data = JSON.parse(raw);
      // Expire after 10 min so a stale snapshot doesn't leak into a later
      // session that didn't actually submit anything.
      if (Date.now() - (data.t || 0) > 600000){
        sessionStorage.removeItem('lfm_submit_snapshot');
        return null;
      }
      return data;
    } catch(_){ return null; }
  }

  // ─── Sync modal rail + hidden fields with live PDP values ────────────────
  function syncRailFromPdp(){
    // In success state, prefer the snapshot we took at submit time over the
    // (now-reset) PDP values. Form state always reads from the live PDP.
    var inSuccess = modal.classList.contains('is-success');
    var snap = inSuccess ? readSubmitSnapshot() : null;

    var qty, totalStr, vidOverride, setupFeeOverride;
    if (snap){
      qty               = snap.quantity;
      totalStr          = snap.total_price;
      vidOverride       = snap.variant_id;
      setupFeeOverride  = snap.setup_fee;
    } else {
      qty      = readPdpQuantity();
      totalStr = readPdpTotalPrice();
    }
    var total = parseMoneyToNumber(totalStr);
    // Guard against reading only the setup fee while the PDP's price
    // calculator is still loading. If total looks like it IS the setup fee,
    // suppress the unit-price / total displays + hidden fields entirely so
    // we don't ship $0.49/unit-style nonsense to Zoho.
    var setupNumGuard = parseMoneyToNumber(
      (setupFeeOverride !== undefined) ? setupFeeOverride : readPdpSetupFee()
    );
    if (total != null && setupNumGuard != null && total <= setupNumGuard + 0.01){
      total    = null;
      totalStr = null;
    }
    var unit = (qty && total) ? (total / qty) : null;

    // Rail — quantity (display "650 units"; hidden field gets numeric "650")
    if (qty != null){
      var qtyEl = modal.querySelector('[data-lfm-rail-qty]');
      if (qtyEl) qtyEl.textContent = qty.toLocaleString('en-US') + ' units';
      var qtySuccessEl = modal.querySelector('[data-lfm-success-qty]');
      if (qtySuccessEl) qtySuccessEl.textContent = qty.toLocaleString('en-US') + ' units';
      var qtyHidden = modal.querySelector('[data-lfm-hidden-qty]');
      if (qtyHidden) qtyHidden.value = String(qty); // numeric — matches legacy product_contact_form.liquid
    }

    // Rail — unit price. Rewrite only the head text node so the sub spans
    // (price-total + price-final) keep their elements and we can target them
    // by data attribute below.
    if (unit != null){
      var priceEl = modal.querySelector('[data-lfm-rail-price]');
      if (priceEl){
        var headText = fmtMoney(unit) + ' / unit';
        if (priceEl.firstChild && priceEl.firstChild.nodeType === 3){
          priceEl.firstChild.nodeValue = headText;
        } else {
          priceEl.insertBefore(document.createTextNode(headText), priceEl.firstChild);
        }
      }
      var priceHidden = modal.querySelector('[data-lfm-hidden-price]');
      if (priceHidden) priceHidden.value = fmtMoney(unit) + ' / unit';
    }

    // Hidden — total estimate
    if (total != null){
      var totalHidden = modal.querySelector('[data-lfm-hidden-total]');
      if (totalHidden) totalHidden.value = fmtMoney(total);
    }

    // Rail — total breakdown sub-line: "$371.25 total + $49 setup fee + shipping"
    // The "Final on quote" line below it is static markup; don't touch it.
    if (qty != null && total != null){
      var priceTotalEl = modal.querySelector('[data-lfm-rail-price-total]');
      if (priceTotalEl){
        var parts = [fmtMoney(total) + ' total'];
        var setupFee = (setupFeeOverride !== undefined) ? setupFeeOverride : readPdpSetupFee();
        if (setupFee) parts.push(setupFee + ' setup fee');
        parts.push('shipping');
        priceTotalEl.textContent = parts.join(' + ');
      }
    }

    // Currently-selected variant id. In success state we use the snapshot we
    // took at submit time; otherwise we read live from the PDP's add-to-cart
    // form. The id is used to (a) update the hidden variant_id field that
    // submits to Shopify, and (b) look up the variant's option values in
    // window.lfmVariantOptions (embedded by lead-form-modal.liquid) so the
    // rail's per-option rows and the hidden contact[variant] /
    // contact[configuration] fields reflect what the customer actually
    // picked on the PDP rather than the page-render snapshot.
    var vid;
    if (vidOverride !== undefined){
      vid = vidOverride;
    } else {
      var variantInput = document.querySelector('form.wt-product__add-to-cart_form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      vid = variantInput && variantInput.value ? String(variantInput.value).trim() : '';
    }
    if (vid){
      var vidHidden = modal.querySelector('[data-lfm-hidden-variant-id]');
      if (vidHidden) vidHidden.value = vid;

      var vopts  = (window.lfmVariantOptions && window.lfmVariantOptions[vid]) || null;
      var onames = window.lfmOptionNames || [];
      // Skip single-variant "Default Title" products so the rail keeps the
      // human-friendly fallback row instead of showing "Title: Default Title".
      var hasOptions = vopts && vopts.length > 0 && !(onames.length === 1 && (onames[0] || '').toLowerCase() === 'title');

      if (hasOptions){
        // Update each rail option row (both form rail and success rail) in
        // place by its index. The success rail uses a different data attribute
        // so the markup can be picked up by both selectors below.
        var optRows = modal.querySelectorAll('[data-lfm-rail-option-val], [data-lfm-success-option-val]');
        for (var oi = 0; oi < optRows.length; oi++){
          var attrName = optRows[oi].hasAttribute('data-lfm-rail-option-val') ? 'data-lfm-rail-option-val' : 'data-lfm-success-option-val';
          var idx = parseInt(optRows[oi].getAttribute(attrName), 10);
          if (!isNaN(idx) && vopts[idx] != null){
            optRows[oi].textContent = vopts[idx];
          }
        }

        // Slash-joined title (matches Shopify's variant.title convention) for
        // the contact[variant] field and the success rail's compact summary.
        var vtitle = vopts.join(' / ');
        // "Name: Value, Name: Value, ..." for contact[configuration] so the
        // inquiry email reads naturally instead of as a bare slash-list.
        var pairs = [];
        for (var pi = 0; pi < onames.length; pi++){
          if (vopts[pi] != null) pairs.push(onames[pi] + ': ' + vopts[pi]);
        }
        var configStr = pairs.join(', ');

        var sCfg = modal.querySelector('[data-lfm-success-config]');
        if (sCfg) sCfg.textContent = vtitle;
        var vHidden = modal.querySelector('[data-lfm-hidden-variant]');
        if (vHidden) vHidden.value = vtitle;
        var cHidden = modal.querySelector('[data-lfm-hidden-config]');
        if (cHidden) cHidden.value = configStr;
      }
    }

    // GCLID — capture from URL once, persist via sessionStorage so deep-link
    // visitors who navigate around still attribute correctly.
    try {
      var gclid = null;
      var urlGclid = new URL(window.location.href).searchParams.get('gclid');
      if (urlGclid){
        gclid = urlGclid;
        try { sessionStorage.setItem('lfm_gclid', gclid); } catch(_){}
      } else {
        try { gclid = sessionStorage.getItem('lfm_gclid'); } catch(_){}
      }
      if (gclid){
        var gHidden = modal.querySelector('[data-lfm-hidden-gclid]');
        if (gHidden) gHidden.value = gclid;
      }
    } catch(_){ /* non-fatal */ }
  }

  // ─── Open / close ────────────────────────────────────────
  function openModal(trigger){
    lastFocusedTrigger = trigger || document.activeElement;
    // Reset state in case modal was previously submitted in this session
    modal.classList.remove('is-loading','is-error','is-success');
    if (cta) cta.disabled = false;
    if (ctaLabel) ctaLabel.innerHTML = (cta && cta.getAttribute('data-cta-label') ? cta.getAttribute('data-cta-label') : 'Send & get options in 1 hour') + '<svg class="lfm-cta-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

    // Sync live values from the PDP before showing
    try { syncRailFromPdp(); } catch(_){ /* non-fatal */ }
    // The PDP's price calculator may not have populated #total-price yet on
    // first paint (esp. with the user opening the modal quickly). Re-sync a
    // couple of times after open so the rail catches the real total once it
    // computes, instead of leaving the suppressed-price guard in place.
    setTimeout(function(){ try { syncRailFromPdp(); } catch(_){} }, 300);
    setTimeout(function(){ try { syncRailFromPdp(); } catch(_){} }, 1200);

    // Pull the Uploadery widget into our drop slot (idempotent; safe to re-run)
    try { syncUploaderyIntoModal(); } catch(_){ /* non-fatal */ }
    // If Uploadery hasn't injected #uploadery-container yet on first open,
    // retry briefly after the modal is visible (helps on cold cache loads).
    setTimeout(function(){ try { syncUploaderyIntoModal(); } catch(_){} }, 500);
    setTimeout(function(){ try { syncUploaderyIntoModal(); } catch(_){} }, 1500);
    // Start polling Uploadery's input value so the drop zone swaps to
    // the "attached" state as soon as the upload completes.
    try { startUploaderyPolling(); } catch(_){}

    modal.classList.add('is-open');
    document.body.classList.add('lfm-open');
    var h = modal.querySelector('.lfm-pane-h');
    if (h) h.setAttribute('tabindex', '-1');
    setTimeout(function(){ if (h) h.focus(); }, 220);
    window.dispatchEvent(new CustomEvent('lead-form:opened'));
  }
  function closeModal(){
    modal.classList.remove('is-open','is-loading','is-error','is-success');
    document.body.classList.remove('lfm-open');
    try { stopUploaderyPolling(); } catch(_){}
    if (lastFocusedTrigger && lastFocusedTrigger.focus) lastFocusedTrigger.focus();
    window.dispatchEvent(new CustomEvent('lead-form:closed'));
  }
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-lead-form-trigger], .openPopup-form');
    if (trigger){
      e.preventDefault();
      e.stopPropagation();
      // Defend against the legacy "openPopup-form" handler also firing on the
      // same button — stop the event before it bubbles further.
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      openModal(trigger);
    }
  }, true); // capture phase so we run before any legacy bubble-phase handlers

  modal.querySelectorAll('[data-lfm-close]').forEach(function(el){
    el.addEventListener('click', closeModal);
  });
  modal.querySelector('.lfm-scrim').addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // ─── File upload ────────────────────────────────────────
  // No custom file handling here anymore. Uploadery owns it: it injects its
  // own widget into #uploadery-container, syncUploaderyIntoModal() moves that
  // into our drop slot, and the hidden URL input it creates submits naturally
  // as contact[file_url] because we renamed it. See the Uploadery integration
  // section above for the moving + renaming logic.

  // ─── Validation ──────────────────────────────────────────
  function setFieldError(name, msg){
    var field = form.querySelector('[data-lfm-field="' + name + '"]');
    if (!field) return;
    if (msg){
      field.classList.add('has-error');
      var msgEl = field.querySelector('.lfm-error-msg');
      if (msgEl) msgEl.textContent = msg;
    } else {
      field.classList.remove('has-error');
    }
  }
  function clearErrors(){
    form.querySelectorAll('.lfm-field.has-error').forEach(function(f){ f.classList.remove('has-error'); });
  }
  function validateForm(){
    clearErrors();
    var errors = {};
    // Case-insensitive field lookup so renaming the Liquid input
    // (e.g., contact[company] vs contact[Company]) doesn't break validation.
    var byName = function(n){
      return form.querySelector('[name="' + n + '"]')
          || form.querySelector('[name="' + n.toLowerCase() + '"]')
          || form.querySelector('[name="' + n.charAt(0).toUpperCase() + n.slice(1) + '"]');
    };
    var name = byName('contact[name]');
    var email = byName('contact[email]');
    var company = form.querySelector('[name="contact[Company]"]') || form.querySelector('[name="contact[company]"]');
    var msg = byName('contact[body]');
    var neededBy = byName('contact[needed_by]');

    if (name && (!name.value.trim() || name.value.trim().length < 2)) errors.name = 'Please tell us your name.';
    if (email){
      if (!email.value.trim()) errors.email = 'Work email is required.';
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) errors.email = 'Please use a valid work email so we can send your quote.';
    }
    if (company && (!company.value.trim() || company.value.trim().length < 2)) errors.company = 'Your company name helps us prioritize.';
    if (msg && (!msg.value.trim() || msg.value.trim().length < 10)) errors.body = 'A few sentences help us reply with useful options.';
    if (neededBy && neededBy.value){
      var today = new Date(); today.setHours(0,0,0,0);
      var nd = new Date(neededBy.value);
      if (!isNaN(nd) && nd < today) errors.needed_by = 'Please pick today or a future date.';
    }

    Object.keys(errors).forEach(function(k){ setFieldError(k, errors[k]); });
    if (Object.keys(errors).length){
      var firstErr = form.querySelector('.lfm-field.has-error');
      if (firstErr){
        firstErr.scrollIntoView({behavior:'smooth', block:'center'});
        var inp = firstErr.querySelector('input,textarea,select');
        if (inp) inp.focus({preventScroll:true});
      }
      return false;
    }
    return true;
  }

  // ─── Submit ──────────────────────────────────────────────
  // The Shopify /contact endpoint returns a 302 redirect that may not be
  // CORS-friendly when read from an AJAX context. To guarantee the user sees
  // the Thank You state, we fire the request in the background and ALWAYS
  // transition to success after a brief minimum loading delay (unless the
  // network completely fails, in which case we show an error).
  form.addEventListener('submit', function(e){
    // ── 1. Validate ──
    var valid;
    try {
      valid = validateForm();
    } catch(err){
      if (window.console && console.error) console.error('[lead-form-modal] validation error:', err);
      valid = false;
    }
    if (!valid){
      // Stop the navigation so the user can fix errors in the modal.
      e.preventDefault();
      return;
    }

    // ── 1.5. Remember the lead for the Meta Lead event (DOT357 / Blotout) ──
    // The native /contact submit reloads the page, so the Lead event is fired
    // from showSuccess() on the reloaded page, using what we stash here.
    try {
      var lfmVal = function(n){ var el = form.querySelector('[name="' + n + '"]'); return el && el.value ? String(el.value).trim() : ''; };
      sessionStorage.setItem('lfm_lead', JSON.stringify({
        t: Date.now(),
        path: location.pathname,
        email: lfmVal('contact[email]'),
        phone: lfmVal('contact[phone]')
      }));
    } catch (_) {}

    // ── 2. Ensure Uploadery's URL input is named correctly ──
    // Belt-and-suspenders: syncUploaderyIntoModal() already does the rename
    // on modal open, but re-confirm right before submit in case Uploadery
    // re-rendered its input after we opened the modal.
    try { syncUploaderyIntoModal(); } catch(_){}

    // ── 2.25. Snapshot the customer's PDP selection ──
    // The Shopify /contact submit triggers a page reload that resets the
    // PDP to its default variant. We stash variant_id, quantity, total,
    // and setup_fee in sessionStorage so the success-state rail can show
    // what the customer actually picked instead of the page-default.
    try { saveSubmitSnapshot(); } catch(_){}

    // ── 2.5. Fire-and-forget POST to N8N for direct CRM (Zoho) enrichment ──
    // Shopify's /contact still fires (email path, backup); this just gets the
    // structured data to Zoho without depending on email parsing. We use
    // mode:'no-cors' with form-encoded body so the browser treats it as a
    // simple request (no preflight). keepalive:true ensures it survives the
    // page navigation triggered by step 4 below. Wrapped in try/catch and
    // .catch() because nothing about this can be allowed to block the form.
    try {
      var fd = new FormData(form);
      var get = function(k){ var v = fd.get(k); return v == null ? '' : String(v); };
      var fields = {
        source:         'Lead Form 2.0',
        form_name:      'Shopify PDP Inquiry',
        name:           get('contact[name]'),
        email:          get('contact[email]'),
        phone:          get('contact[phone]'),
        company:        get('contact[Company]') || get('contact[company]'),
        notes:          get('contact[body]'),
        needed_by:      get('contact[needed_by]'),
        quantity:       get('contact[quantity]'),
        product_name:   get('contact[product]'),
        product_id:     get('contact[product_id]'),
        product_url:    get('contact[link]'),
        variant_title:  get('contact[variant]'),
        variant_id:     get('contact[variant_id]'),
        configuration:  get('contact[configuration]'),
        file_url:       get('contact[file_url]'),
        est_price_band: get('contact[est_price_band]'),
        total_estimate: get('contact[total_estimate]'),
        gclid:          get('contact[gclid]'),
        // Meta click/browser IDs -> stored on the Zoho lead for later CAPI
        // "Qualified Lead" / "Purchase" events. Not a Lead event itself.
        fbc:            lfmFbc(),
        fbp:            lfmCookie('_fbp'),
        page_title:     document.title || '',
        page_href:      window.location.href || '',
        time_zone:      (function(){ try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch(_){ return ''; } })()
      };
      var params = new URLSearchParams();
      Object.keys(fields).forEach(function(k){ params.append(k, fields[k]); });
      fetch('https://thfab.app.n8n.cloud/webhook/shopify-pdp-lead', {
        method: 'POST',
        body: params,
        mode: 'no-cors',
        keepalive: true
      }).catch(function(){ /* fire-and-forget */ });
    } catch(_){ /* never block the form */ }

    // ── 3. Show loading state ──
    // The browser will navigate to /contact in the next tick. Painting this
    // state is mostly for the brief window between click and navigation, and
    // covers the case where the browser is slow to actually move pages.
    modal.classList.remove('is-error');
    modal.classList.add('is-loading');
    if (cta) cta.disabled = true;
    if (ctaLabel) ctaLabel.innerHTML = '<span class="lfm-cta-spinner"></span>Sending your request…';
    if (bannerEl) bannerEl.textContent = '';

    // ── 4. Let the form submit natively ──
    // No preventDefault. The browser POSTs to /contact, Shopify processes the
    // submission (including any CAPTCHA challenge — handled by the browser as
    // a normal page navigation, which AJAX couldn't do), and redirects back
    // to this page with ?contact_posted=true. On that redirected page load,
    // the bottom of this file detects the param and re-opens the modal in
    // the success state.
  });

  function showSuccess(){
    modal.classList.remove('is-loading','is-error');
    modal.classList.add('is-success');
    // Sync the success rail's quantity from the live PDP (in case user re-opened the modal)
    try { syncRailFromPdp(); } catch(_){}
    window.dispatchEvent(new CustomEvent('lead-form:submitted'));

    // Meta Lead event via Blotout (DOT357). Fires once, only when this page
    // load is the redirect back from a real submit made in the last 10 min.
    try {
      var lead = JSON.parse(sessionStorage.getItem('lfm_lead') || 'null');
      sessionStorage.removeItem('lfm_lead');
      if (lead && lead.path === location.pathname && Date.now() - lead.t < 600000) {
        var fireLead = function () {
          var u = {};
          if (lead.email) u.email = lead.email;
          if (lead.phone) u.phone = lead.phone;
          if (u.email || u.phone) edgetag('data', u);
          edgetag('tag', 'Lead', { name: 'PDP quote popup' });
        };
        if (window.edgetag) { fireLead(); } else {
          var n = 0, t = setInterval(function () {
            if (window.edgetag || ++n > 150) { clearInterval(t); if (window.edgetag) fireLead(); }
          }, 200);
        }
      }
    } catch (_) {}
  }

  // Meta browser IDs for the Zoho lead (see fields in the submit handler).
  function lfmCookie(n){
    try { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; } catch(_){ return ''; }
  }
  function lfmFbc(){
    var c = lfmCookie('_fbc'); if (c) return c;
    try {
      var id = new URLSearchParams(location.search).get('fbclid');
      return id ? 'fb.1.' + Date.now() + '.' + id : '';
    } catch(_){ return ''; }
  }

  // Detect Shopify-native success redirect: if URL has ?contact_posted=true,
  // open modal in success state on load. (Fallback for non-AJAX submission.)
  if (/[?&]contact_posted=true/.test(window.location.search)){
    openModal();
    showSuccess();
  }
})();
